/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RightBuccalWithRetractors/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RightBuccalWithRetractors({
  children,
  viewPath = "/DesignSystem/Images/RightBuccalWithRetractors",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 286,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 274
  
}) {
  return (<React.Fragment
>
<img
  data-testid="RightBuccalWithRetractors.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-ZUUccp': alignSelf,'--bc-2-ZUUccp': backgroundColor,'--bblr-3-ZUUccp': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-ZUUccp': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-ZUUccp': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-ZUUccp': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-ZUUccp': typeof height === 'number' ? `${height}px` : height,'--mb-8-ZUUccp': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-ZUUccp': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-ZUUccp': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-ZUUccp': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-ZUUccp': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}